import { useEffect, useCallback } from "react";
import { useInterval } from "./useInterval.js";

/**
 * Custom hook that manages shared data loading intervals. While the app has multiple
 * context (asset & downtime) some of the data, like Asset Status, is shared. Therefore,
 * it is better to load the data on the same interval.
 * @param {Object} options - Configuration options
 * @param {number} options.intervalMs - Interval in milliseconds (default: 15 minutes)
 * @param {Function} options.onLoad - Callback function called when interval triggers
 * @returns {Object} Object containing loading state and trigger function
 */
export const useDataLoader = ({ intervalMs = 900000, onLoad }) => {
  /**
   * Trigger data loading for all subscribed contexts
   */
  const triggerDataLoad = useCallback(() => {
    if (onLoad && typeof onLoad === "function") {
      onLoad();
    }
  }, [onLoad]);

  // Set up interval to trigger data loading
  useInterval(() => {
    triggerDataLoad();
  }, intervalMs);

  // Initial load on mount
  useEffect(() => {
    triggerDataLoad();
  }, [triggerDataLoad]);

  return {
    triggerDataLoad,
  };
};
